import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here

import Localization from "../../Localization.jsx"

import SchoolList from "../../views/storage/SchoolList.jsx"
import UserList from "../../views/storage/UserList.jsx"

import {
  Button,
  TextField,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Divider,
  InputAdornment,
  IconButton,
  Icon,
} from '@material-ui/core';

class AdminCreateUserForm extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      newUser: {
        schoolID: -1,
        schoolKey: "",
        role: 1,
        demoLocaleID: "",
        username: "",
        displayName: "",
        password: "",
        email: "",
      },
      userList: [],
      demoLocaleName: "",
    };
    autoBind(this);
  }

  handleChange = name => event => {
    let user = this.state.newUser;
    user[name] = event.target.value;
    this.setState({ newUser: user });
    this.state.newUser = user;
  }

  onSchoolSelected(school) {
    if (school != null) {
      let user = this.state.newUser;
      user['schoolID'] = school.value;
      user['schoolKey'] = school.key;
      user['username'] = "s" + school.value;
      this.setState({
        newUser: user,
      });
      this.state.newUser = user;

      this.props.root.refs.API.request("get_user_data_by_school_id", {school_id: school.value}, this.getUserDataBySchoolIdOK, this.getUserDataBySchoolIdFailed);
    }
  }

  getUserDataBySchoolIdOK(res) {
    let sortedData = res.body['result'].sort(function(a, b) {
      if (a['username'].toLowerCase() < b['username'].toLowerCase()) {
        return -1;
      }
      else if (a['username'].toLowerCase() > b['username'].toLowerCase()) {
        return 1;
      }
      else {
        return (parseInt(a['id']) < parseInt(b['id']) ? -1 : 1);
      }
    });
    this.setState({
      userList: sortedData,
    })
    this.state.userList = sortedData;
  }

  getUserDataBySchoolIdFailed(err) {
    console.log("get user data by school id failed");
  }

  validateInput() {
    let result = true;
    let errorMessage = "";
    let illegalChars = /[\W_]/;
    let password = this.state.newUser.password.trim();

    if (this.state.newUser.schoolID < 0 || this.state.newUser.schoolKey == "") {
      errorMessage = "School cannot be blank";
      result = false;
    }
    else if (this.state.newUser.username.trim() == "") {
      errorMessage = "Username cannot be blank";
      result = false;
    }
    else if (this.state.newUser.displayName.trim() == "") {
      errorMessage = "Display name cannot be blank";
      result = false;
    }
    else if (this.state.newUser.email.trim() !== "" && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.newUser.email)) {
      errorMessage = "Email is not in a valid format";
      result = false;
    }
    else if (this.state.newUser.password.trim() == "") {
      errorMessage = "Password cannot be blank";
      result = false;
    }
    else if (illegalChars.test(password)) {
      errorMessage = "Password contains illegal characters, only letter and number allowed";
      result = false;
    }
    else if ((password.search(/[a-zA-Z]+/) == -1) || (password.search(/[0-9]+/) == -1)) {
      errorMessage = "Password should contains both letters and digits";
      result = false;
    }
    else if (password.length < 6) {
      errorMessage = "Password should be longer than 6 characters";
      result = false;
    }
    else if (password.length > 30) {
      errorMessage = "Password should be shorter than 30 characters";
      result = false;
    }
    

    for (let i = 0; i < this.state.userList.length; i++) {
      let user = this.state.userList[i];
      if (user['username'] == this.state.newUser.username) {
        errorMessage = "Username already taken";
        result = false;
      }
    }

    if (this.state.newUser.demoLocaleID.trim() != "" && this.state.demoLocaleName == "") {
      errorMessage = "Demo locale is invalid";
      result = false;
    }

    if (errorMessage != "") {
      this.props.root.addNotification(errorMessage);
    }

    return result;
  }

  createUserClicked() {
    if (this.validateInput()) {
      let requestObj = {};
      requestObj['username'] = this.state.newUser.username.trim();
      requestObj['display_name'] = this.state.newUser.displayName.trim();
      requestObj['email'] = this.state.newUser.email.trim();
      requestObj['password'] = this.state.newUser.password.trim();
      requestObj['role'] = this.state.newUser.role;
      requestObj['school_id'] = this.state.newUser.schoolID;

      this.props.root.refs.API.request("user_create", requestObj, this.createUserOK, this.createUserFailed);
    }
  }

  createUserOK(res) {
    let newUserID = res.body['result'];
    if (newUserID > 0) {
      if (this.state.newUser.demoLocaleID != "") {
        let requestObj = {};
        requestObj['user_id'] = newUserID;
        requestObj['locale_id'] = this.state.newUser.demoLocaleID;

        this.props.root.refs.API.request("locale_duplicate", requestObj, this.duplicateLocaleOK, this.duplicateLocaleFailed);
      }
      this.props.root.addNotification(Localization.strings.CREATED);
    }
  }

  createUserFailed(err) {
    console.log("create user failed " + err);
  }

  duplicateLocaleOK(res) {
    let newLocaleID = res.body['result'];
    let requestObj = {};
    requestObj['id'] = newLocaleID;
    requestObj['is_ready'] = 1;
    requestObj['is_share'] = 0;

    this.props.root.refs.API.request("update_locale", requestObj, this.updateLocaleOK, this.updateLocaleFailed);
  }

  duplicateLocaleFailed(err) {
    console.log("duplicate locale failed");
  }

  updateLocaleOK(res) {

  }

  updateLocaleFailed(err) {
    console.log("update locale failed");
  }

  clearDemoLocale() {
    let user = this.state.newUser;
    user['demoLocaleID'] = "";

    this.setState({
      newUser: user,
      demoLocaleName: "",
    });
    this.state.newUser = user;
    this.state.demoLocaleName = "";
  }

  searchLocaleClicked() {
    if (this.state.newUser.demoLocaleID.trim() != "") {
      let requestObj = {};
      requestObj['locale_id'] = this.state.newUser.demoLocaleID.trim();
      console.log('locale_id:', requestObj['locale_id']);
      this.props.root.refs.API.request("get_locale_data_by_id", requestObj, this.getLocaleDataByIdOK, this.getLocaleDataByIdFailed);
    }
  }

  getLocaleDataByIdOK(res) {
    let localeName = res.body['result'].locale_name;
    this.setState({
      demoLocaleName: localeName,
    });
    this.state.demoLocaleName = localeName;
  }

  getLocaleDataByIdFailed() {
    console.log("get locale data by id failed");
    this.setState({
      demoLocaleName: "",
    });
    this.state.demoLocaleName = "";
  }

  render() {
    return (
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={2}>
            School Name
          </Grid>
          <Grid item xs={12} sm={10}>
            <SchoolList parent={this} root={this.props.root} ref="schoolList"
              onSchoolSelected={this.onSchoolSelected}
              hasLabel={false}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            School ID
          </Grid>
          <Grid item xs={12} sm={10}>
            <TextField
              disabled
              value={(this.state.newUser.schoolID < 0? "" : this.state.newUser.schoolID)}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            School Key
          </Grid>
          <Grid item xs={12} sm={10}>
            <TextField
              disabled
              value={this.state.newUser.schoolKey}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            Existing User
          </Grid>
          <Grid item xs={12} sm={10}>
            <UserList parent={this} root={this.props.root}
              userOption={0}
              userList={this.state.userList}
              hasLabel={false}
              showUsername={true}
            />
          </Grid>
          <Grid item xs={12}>
            <Divider variant="middle" style={{margin:"14px 0 14px 0"}}/>
          </Grid>
          <Grid item xs={12} sm={2}>
            Role
          </Grid>
          <Grid item xs={12} sm={10}>
            <FormControl>
              <Select
                value={this.state.newUser.role}
                onChange={this.handleChange('role')}
              >
                <MenuItem value={0}>Student</MenuItem>
                <MenuItem value={1}>Teacher</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2}>
            Username
          </Grid>
          <Grid item xs={12} sm={10}>
            <TextField
              value={this.state.newUser.username}
              onChange={this.handleChange('username')}
              helperText="Should be unique"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            Display Name
          </Grid>
          <Grid item xs={12} sm={10}>
            <TextField
              value={this.state.newUser.displayName}
              onChange={this.handleChange('displayName')}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            Email
          </Grid>
          <Grid item xs={12} sm={10}>
            <TextField
              value={this.state.newUser.email}
              onChange={this.handleChange('email')}
              helperText="Optional"
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            Password
          </Grid>
          <Grid item xs={12} sm={10}>
            <TextField
              value={this.state.newUser.password}
              onChange={this.handleChange('password')}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            Demo Locale
          </Grid>
          <Grid item xs={12} sm={10}>
            <If condition={this.state.demoLocaleName == ""}>
              <Then>
                <TextField
                  value={this.state.newUser.demoLocaleID}
                  onChange={this.handleChange('demoLocaleID')}
                  InputProps={{
                    endAdornment:
                      <InputAdornment position="end">
                        <IconButton onClick={this.searchLocaleClicked}>
                          <Icon>search</Icon>
                        </IconButton>
                      </InputAdornment>
                  }}
                />
              </Then>
              <Else>
                <TextField
                  value={this.state.demoLocaleName}
                  InputProps={{
                    endAdornment:
                      <InputAdornment position="end">
                        <IconButton onClick={this.clearDemoLocale}>
                          <Icon>clear</Icon>
                        </IconButton>
                      </InputAdornment>
                  }}
                />
              </Else>
            </If>
          </Grid>
          <Grid item xs={12} sm={2}>
          </Grid>
          <Grid item xs={12} sm={10}>
            <Button
              color="primary"
              variant="contained"
              onClick={this.createUserClicked}
            >
              {Localization.strings.CREATE}
            </Button>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default AdminCreateUserForm;
